// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__l+SZl","logo":"MainHeader_logo__8eJTK","subtitle":"MainHeader_subtitle__E23iI"};